import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

export default function PageLoader({ height = "73vh" }) {
  return (
    <div className="container-fluid">
      <div
        className="row justify-content-center align-items-center"
        style={{ height: height }}
      >
        <div className="col-12 text-center">
          <CircularProgress />
        </div>
      </div>
    </div>
  );
}
